import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../Pages/Navbar/Navbar';
import './Training.css';
import defaultImage from "./images/students.png"
import { FaMapMarkerAlt, FaInfoCircle, FaPhone, FaUser, FaStar } from "react-icons/fa";
import BaseUrl from '../../ApiServices/BaseUrl';

function Training() {
  const [trainings, setTrainings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchTrainings();
  }, []);

  const fetchTrainings = async () => {
    try {
      const response = await fetch(`${BaseUrl}/trainings/all`);
      if (!response.ok) {
        throw new Error('Failed to fetch trainings');
      }
      const data = await response.json();
      setTrainings(data);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const handleViewDetails = (trainingId) => {
    navigate(`/individual-training?id=${trainingId}`);
  };

  if (loading) {
    return (
      <>
        <Navbar />
        <div className="trng-container trng-training-container">
          <div className="text-center mt-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2">Loading trainings...</p>
          </div>
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        <Navbar />
        <div className="trng-container trng-training-container">
          <div className="alert alert-danger text-center mt-5" role="alert">
            Error: {error}
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div className="trng-container trng-training-container">
        {/* Top Section */}
        <h2 className="training-title-wrapper">
          <div className='Training-title'>
            <FaUser className="training-title-icon" />
            <span className="training-title-text">Training</span>
          </div>
        </h2>

        <div className="text-center mb-4 trng-training-header">
          <h2 className="trng-title">
            <i className="fas fa-phone-alt trng-contact-icon"></i> 
            <span className="trng-title-text">The Best Domestic Workers Trainings</span>
          </h2>
          <p className="trng-subtitle">
            A lot of trainings are available to provide to Foreign Domestic Workers more experience 
            (caregiver certificate, CPR and first aid classes, childcare) and help employer to improve 
            the skills of their helpers (cooking, housekeeping, languages, driving..). We are listing 
            the best trainings for any helper.
          </p>
        </div>

        {/* Dropdowns */}
        <div className="trng-card trng-dropdown-card p-3 mx-auto mb-3">
          <div className="trng-dropdown-row">
            <div className="trng-custom-dropdown">
              <select>
                <option>Country</option>
                <option>Hong Kong</option>
                <option>Singapore</option>
                <option>UAE</option>
              </select>
            </div>

            <div className="trng-custom-dropdown">
              <select>
                <option>Services</option>
                <option>Caregiver Training</option>
                <option>Online Training</option>
                <option>Housekeeping</option>
              </select>
            </div>

            <div className="trng-custom-dropdown">
              <select>
                <option>Most Popular</option>
                <option>Top Rated</option>
                <option>New</option>
              </select>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          {trainings.map((training) => (
            <div key={training.id} className="col-md-4 mb-4">
              <div className="trng-card trng-service-card h-100 shadow-sm position-relative">
                {/* Banner Image */}
                <img 
                  src={training.back_profile || defaultImage} 
                  alt={`${training.training_title} Banner`} 
                  className="trng-card-img-top trng-banner-img" 
                />

                {/* Logo */}
                <img 
                  src={training.profile_image || defaultImage} 
                  alt={`${training.training_title} Logo`} 
                  className="rounded-circle trng-logo-img" 
                />

                {/* Rating */}
                <div className="trng-rating-badge">
                  <FaStar className="trng-star-icon" />
                  <span>{training.rating}</span>
                </div>

                <div className="trng-card-body">
                  {/* Location */}
                  <div className="d-flex justify-content-end mb-2">
                    <span className="trng-location-text">
                      <FaMapMarkerAlt className="trng-location-icon" /> {training.location}
                    </span>
                  </div>

                  <h3 className="trng-tenderheart-home">{training.training_title}</h3>
                  <p className="trng-card-text text-black trng-description">
                    {training.description}
                  </p>

                  <h5 className="mt-4 trng-service-subheading text-blue text-start">
                    Our Services:
                  </h5>
                  <span className="trng-badge trng-training-badge">{training.our_services}</span>

                  <div className="d-flex justify-content-around mt-4 trng-card-buttons">
                    <button className="btn btn-success rounded-pill trng-contact-btn">
                      <FaPhone /> CONTACT US
                    </button>
                    <button 
                      className="btn btn-warning rounded-pill trng-details-btn"
                      onClick={() => handleViewDetails(training.id)}
                    >
                      <FaInfoCircle /> MORE DETAILS
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default Training;